import Breadcrumbs from 'Components/Breadcrumbs'
import PageTitle from 'Components/PageTitle'
import TariffCatalogForm from 'Services/ProductManagement/Features/Tariff/Components/TariffCatalogForm'
import { PRODUCT_MANAGEMENT_ROOT_URL } from 'Util/constants'
import { Box, Grid } from '@mui/material'
import { useParams } from 'react-router-dom'
import { t } from 'ttag'

function TariffCatalogCreatePage() {
  const { id: tariffId } = useParams()
  const baseUrl = `${PRODUCT_MANAGEMENT_ROOT_URL}/tariffs/${tariffId}/sales-channels`

  const breadcrumbs = [
    {
      title: t`Home`,
      link: PRODUCT_MANAGEMENT_ROOT_URL
    },
    {
      title: t`Tariff sales channels`
    },
    {
      title: t`Create new sales channel`
    }
  ]

  return (
    <Box sx={{ width: '100%' }}>
      <Grid container spacing={2} mb={4}>
        <Grid size={12}>
          <Breadcrumbs items={breadcrumbs} />
          <PageTitle>{t`Create new sales channel`}</PageTitle>
        </Grid>
      </Grid>
      <TariffCatalogForm successBaseUrl={baseUrl} />
    </Box>
  )
}

export default TariffCatalogCreatePage
